import { render } from "./AttachmentsByType.vue?vue&type=template&id=60531810&ts=true"
import script from "./AttachmentsByType.vue?vue&type=script&lang=ts"
export * from "./AttachmentsByType.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__